"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsExtensionsSettingsDialogComponent = void 0;
var React = require("react");
var ScreenTypes_1 = require("../util/ScreenTypes");
var ConnectionScreen_1 = require("./ConnectionScreen");
var EinsteinDiscoveryScreen_1 = require("./EinsteinDiscoveryScreen");
var MenuScreen_1 = require("./MenuScreen");
var AnalyticsExtensionsSettingsDialogComponent = function (props) {
    var onSetConnection = props.onSetConnection, initialScreenType = props.initialScreenType;
    var _a = React.useState(initialScreenType), currentScreen = _a[0], setCurrentScreen = _a[1];
    var _b = React.useState(initialScreenType !== ScreenTypes_1.ScreenType.Menu), isEnabled = _b[0], setIsEnabled = _b[1];
    var onMenuSelection = function (selection) {
        checkServerSavedAccessTokensEnabledForEinstein(selection);
        setCurrentScreen(selection);
    };
    var checkServerSavedAccessTokensEnabledForEinstein = function (selection) {
        if (selection === ScreenTypes_1.ScreenType.EinsteinDiscovery && props.savedAccessTokensEnabled !== undefined && !props.savedAccessTokensEnabled) {
            if (props.onEinsteinDiscoverySelectedWithNoSavedAccessTokensEnabled !== undefined) {
                props.onEinsteinDiscoverySelectedWithNoSavedAccessTokensEnabled();
            }
        }
    };
    var onBackClicked = function (selection) {
        props.onClearContent();
        onMenuSelection(selection);
    };
    var updateIsEnabled = function (enabled) {
        setIsEnabled(enabled);
    };
    switch (currentScreen) {
        case ScreenTypes_1.ScreenType.Menu:
            return React.createElement(MenuScreen_1.MenuScreen, { onMenuSelection: onMenuSelection, isOnline: props.isOnline });
        case ScreenTypes_1.ScreenType.EinsteinDiscovery:
            return (React.createElement(EinsteinDiscoveryScreen_1.EinsteinDiscoveryScreen, { onBack: onBackClicked, onClose: props.onCancel, onSetConnection: onSetConnection, isEnabled: isEnabled, updateIsEnabled: updateIsEnabled, savedAccessTokensEnabled: props.savedAccessTokensEnabled }));
        default:
            return (React.createElement(ConnectionScreen_1.ConnectionScreen, { onBack: onBackClicked, onCancel: props.onCancel, onSetConnection: onSetConnection, connectionParams: props.connectionParams, screenType: currentScreen }));
    }
};
exports.AnalyticsExtensionsSettingsDialogComponent = AnalyticsExtensionsSettingsDialogComponent;
//# sourceMappingURL=AnalyticsExtensionsSettingsDialogComponent.js.map